import { z } from 'zod';
import { IAsset } from './IAsset';
import { IAssetCategoryId } from './IAssetCategory';
import { IAssetTypeId } from './IAssetType';
import { GenericAssetSchema } from './IGenericAsset';

export const MortgageAssetVersion = {
  Initial: 1,
} as const;

export type MortgageAssetVersion =
  (typeof MortgageAssetVersion)[keyof typeof MortgageAssetVersion];

export function getEmptyMortgageAsset(idAsset: number): IMortgageAsset {
  return {
    idAsset,
    idAssetType: IAssetTypeId.Mortgage,
    idAssetCategory: IAssetCategoryId.Liabilities,
    Version: MortgageAssetVersion.Initial,
    data: {
      value: 0,
      idRealEstate: 0,
      notes: '',
    },
  };
}

export function isMortgageAsset(asset: IAsset): asset is IMortgageAsset {
  return asset.idAssetType === IAssetTypeId.Mortgage;
}

export const MortgageAssetDataSchema = z.object({
  value: z.number(),
  idRealEstate: z.number().int(),
  notes: z.string().optional(),
});

export const MortgageAssetSchema = GenericAssetSchema(
  z.literal(IAssetTypeId.Mortgage),
  z.literal(IAssetCategoryId.Liabilities),
  z.literal(MortgageAssetVersion.Initial).optional(),
  MortgageAssetDataSchema
);

export type IMortgageAsset = z.infer<typeof MortgageAssetSchema>;
